import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import About from './components/About';
import Project from './components/Project';
import Contact from './components/Contact';
import Footer from './components/Footer';

const App = () => {
  const [isNavOpen, setNavOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  const handleScroll = () => {
    setNavOpen(false);

    if (window.pageYOffset > 30) {
      document.querySelector('header').classList.add('header-active');
    } else {
      document.querySelector('header').classList.remove('header-active');
    }

    document.querySelectorAll('section').forEach((section) => {
      const id = section.id;
      const height = section.clientHeight;
      const offset = section.offsetTop - 200;
      const top = window.pageYOffset;

      if (top >= offset && top < offset + height) {
        setActiveSection(id);
      }
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('load', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('load', handleScroll);
    };
  }, []);

  return (
    <div>
      <Header isNavOpen={isNavOpen} toggleNav={() => setNavOpen(!isNavOpen)} activeSection={activeSection} />
      <About />
      <Project />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
